import { createContext } from 'react'

import { createKindRootNodeStore } from '../store/createStore'

export const KindRootNodeStoreContext = createContext<
  ReturnType<typeof createKindRootNodeStore> | undefined
>(undefined)
